import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useI18n } from '../utils/I18n/context';
import { I18nFormatter } from '../utils/I18n/I18n';

const Timer = ({ time, onStop }) => {
    const { t } = useI18n();
    const [seconds, setSeconds] = useState(time);
    const [format, setFormat] = useState(I18nFormatter.duration(time));

    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 0) {
                    clearInterval(timer);
                    onStop?.();
                    return 0;
                }
                const newSeconds = prev - 1;
                setFormat(I18nFormatter.duration(newSeconds));
                return newSeconds;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [onStop]);

    return <span>{format}</span>;
};

Timer.propTypes = {
    time: PropTypes.number,
    onStop: PropTypes.func,
};

Timer.defaultProps = {
    time: 0,
    onStop: () => {},
};

export default Timer;